import React from "react";
import { motion } from 'framer-motion';

const MobFilterItem = ({title, projNum, fiIdx, isCurActive, handleFilterSelection}) => {
    const mobFilterItemVariants= {
        initial: {
        }, animate: {
            transition: {
                delayChildren: fiIdx * 0.15
            }
        }, exit: {
            transition: {
                delayChildren: 0,
                staggerChildren: 0.05
            }
        }
    }

    const mobFiVariants = {
        initial: {
            opacity: 0,
            transform: "translate3d(0, 100%, 0)"
        }, animate: {
            transform: "translate3d(0, 0%, 0)",
            opacity: 1,
            transition: {
                duration: 1.5,
                ease: [0.16, 1, 0.3, 1]
            }
        }, exit: {
            transform: "translate3d(0, 100%, 0)",
            opacity: 0,
            transition: {
                duration: 0.5,
                ease: [0.76, 0, 0.24, 1]
            }
        }
    }

    const mobProjNumVariants = {
        initial: {
            transform: "translate3d(0, 100%, 0)"
        }, animate: {
            transform: "translate3d(0, 0%, 0)",
            transition: {
                delay: 0.45 + fiIdx*0.15,
                duration: 2,
                ease: [0.16, 1, 0.3, 1]
            }
        }, exit: {
            transform: "translate3d(0, -100%, 0)",
            transition: {
                duration: 1.25,
                ease: [0.7, 0, 0.84, 0]
            }
        }
    }

    return (
        <>
            <motion.div
                className={`archv_mob_filter_item ${isCurActive ? "mob_act_filt" : ""}`}
                variants={mobFilterItemVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                onClick={() => {handleFilterSelection(Number(fiIdx))}}
            >
                <motion.span 
                    className={"mob_fi_name"}
                    variants={mobFiVariants}
                >                
                    {title.toLocaleLowerCase()}
                </motion.span>
            </motion.div>
        </>
    )
}

export default MobFilterItem;